import { render } from "./FormTextarea.vue?vue&type=template&id=2fe5fa32"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/form/FormTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fe5fa32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fe5fa32', __exports__)) {
    api.reload('2fe5fa32', __exports__)
  }
  
  module.hot.accept("./FormTextarea.vue?vue&type=template&id=2fe5fa32", () => {
    api.rerender('2fe5fa32', render)
  })

}


export default __exports__